import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './components/app/app.component';
import { AppContext } from './app.context';
import { BaseComponent } from './components/base/base.component';
import { HomeComponent } from './components/home/home.component';
import { PrimengModule } from './primeng.module';
import { AppMessageService } from "./services/app-message.service";
import { HelpLinkComponent } from "./shared/help-link/help-link.component";
import { GridComponent } from "./shared/grid/grid.component";

import { DataService } from "./services/data.service";
import { HttpErrorHandler } from "./services/http-error-handler";
import { ReferenceDataService } from "./services/reference-data.service";
import { AppInsightsService } from "./services/app-insights.service";
import { AppResolver } from "./app.resolver";
import { MessagesComponent } from "./components/messages/messages.component";
import { DataExplorerFilterComponent } from "./shared/data-explorer-filter/data-explorer-filter.component";
import { NewsAnnouncementsComponent } from "./shared/news-announcements/news-announcements.component";
import { NewsAnnouncementsService } from "./shared/news-announcements/news-announcements.service";
import { NgxTurnstileModule } from "ngx-turnstile";
import { CaptchaService } from "./services/captcha.service";
import { EntitiesService } from "./services/entities.service";
import { EntityTypesService } from "./services/entity-types.service";
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';

const routes: Routes = [{
  path: '', resolve: { app: AppResolver }, component: HomeComponent, pathMatch: 'full'
}];

@NgModule({
  declarations: [
    AppComponent,
    BaseComponent,
    DataExplorerFilterComponent,
    GridComponent,
    HomeComponent,
    HelpLinkComponent,
    MessagesComponent,
    NewsAnnouncementsComponent,
  ],
  bootstrap: [
    AppComponent
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    CommonModule,
    FormsModule,
    HttpClientModule,
    RouterModule.forRoot(routes),
    PrimengModule,
    ReactiveFormsModule,
    NgxTurnstileModule,
    ButtonModule,
    TableModule,
  ],
  exports: [
    DataExplorerFilterComponent,
    GridComponent,
    MessagesComponent,
    NewsAnnouncementsComponent,
  ],
  providers: [
    AppContext,
    AppInsightsService,
    AppMessageService,
    AppResolver,
    CaptchaService,
    DataService,
    HttpErrorHandler,
    NewsAnnouncementsService,
    ReferenceDataService,
    EntitiesService,
    EntityTypesService
  ]
})
export class AppModule {
  constructor() { }
}
